import type { CandidateFormItemFormatType, CandidateFormItemFormType } from '@/types/serializers';

/**
 * CandidateFormItem のフォーマット制限選択肢
 */
export const candidateFormItemFormatTypeOptions: {
  value: CandidateFormItemFormatType;
  label: string;
}[] = [
  { value: 'nothing', label: '制限なし' },
  { value: 'email', label: 'メールアドレス' },
  { value: 'tel', label: '電話番号' },
  { value: 'tel_hyphen', label: '電話番号（ハイフン付き）' },
  { value: 'url', label: 'URL' },
  { value: 'hiragana', label: 'ひらがな' },
  { value: 'katakana', label: 'カタカナ' },
  { value: 'number', label: '数字' },
];

/**
 * CandidateFormItem のフォーム種別ラベル
 */
export const candidateFormItemFormTypeLabels = {
  text: '一行テキスト',
  textarea: '複数行テキスト',
  selectbox: 'セレクトボックス',
  radio: 'ラジオボタン',
  checkbox: 'チェックボックス',
  date: '日付',
  file: 'ファイル',
} as const satisfies Record<CandidateFormItemFormType, string>;

/**
 * CandidateFormItem のフォーム種別選択肢
 */
export const candidateFormItemFormTypeOptions: {
  value: CandidateFormItemFormType;
  label: string;
}[] = [
  { value: 'text', label: candidateFormItemFormTypeLabels.text },
  { value: 'textarea', label: candidateFormItemFormTypeLabels.textarea },
  { value: 'selectbox', label: candidateFormItemFormTypeLabels.selectbox },
  { value: 'radio', label: candidateFormItemFormTypeLabels.radio },
  { value: 'checkbox', label: candidateFormItemFormTypeLabels.checkbox },
  { value: 'date', label: candidateFormItemFormTypeLabels.date },
  { value: 'file', label: candidateFormItemFormTypeLabels.file },
];

/** 選択系のフォーム種別（セレクトボックス・ラジオ・チェックボックスのみ） */
export const selectableFormTypeOptions = candidateFormItemFormTypeOptions.filter(
  (opt) => opt.value === 'selectbox' || opt.value === 'radio' || opt.value === 'checkbox'
);

/**
 * CandidateFormItem のフォーム種別ラベルを取得
 */
export function getCandidateFormItemFormTypeLabel(
  formType: CandidateFormItemFormType | string
): string {
  if (formType in candidateFormItemFormTypeLabels) {
    return candidateFormItemFormTypeLabels[formType as CandidateFormItemFormType];
  }
  return formType;
}
